import { render } from "./pdf.vue?vue&type=template&id=78d35abd"
const script = {}
script.render = render

export default script